<template>
  <div class="app-filters-options-list">
    <div class="row">
      <div class="title">{{ $t("filters") }}</div>
      <div class="description" v-if="!optionLength">{{ $t("no_filters_found_message") }}</div>
    </div>

    <div class="row filter-options" v-for="(filter, fIndex) in options" :key="`filter-${fIndex}`">
      <div class="action">
        <FIcon name="close" size="1.1rem" @click.native="() => handleOnRemoveFilter(fIndex)" />
      </div>

      <div class="column --col-limited">
        <v-select
          :items="columns"
          :label="$t('column')"
          item-text="text"
          item-id="value"
          solo
          class="--drop-down-option"
          v-model="filter.column"
          :attach="`#filter-column-${fIndex}`"
        />
        <div :id="`filter-column-${fIndex}`" class="select-attach"></div>
      </div>

      <div class="contain --col-limited">
        <v-select
          :items="contains"
          :label="$t('contain')"
          item-text="value"
          item-id="id"
          solo
          class="--drop-down-option"
          v-model="filter.contain"
          :attach="`#filter-contain-${fIndex}`"
        />
        <div :id="`filter-contain-${fIndex}`" class="select-attach" />
      </div>

      <div class="value --col-limited">
        <label class="d-flex" :for="`app_filter_option_value${fIndex}`">
          <input
            class="--filter-input"
            :id="`app_filter_option_value${fIndex}`"
            :placeholder="$t('filter_input_placeholder')"
            v-model="filter.value"
          />
        </label>
      </div>
    </div>

    <div class="row add-filter">
      <Link :title="$t('add_filters')" @click.native="handleOnCreateNewFilter">
        <template #prepend>
          <FIcon name="plus" :color="'#42c3fe'" size="1.1rem" />
        </template>
      </Link>
    </div>
  </div>
</template>

<script>
import contains from "./options";
import { mapGetters } from "vuex";

export default {
  name: "AppFiltersOptionsList",

  data() {
    return {
      contains,
      isLoading: true,
    };
  },

  computed: {
    ...mapGetters({
      filter: "App/filter",
    }),

    /**
     * Columns
     * @return {Array<any>}
     */
    columns() {
      return this.filter.columns.filter((column) => !!column.text);
    },

    /**
     * Options
     * @return {Array<any>}
     */
    options() {
      return this.filter?.options || [];
    },

    /**
     * Options length
     * @return {number}
     */
    optionLength() {
      return this.filter?.options?.length;
    },
  },

  watch: {
    "filter.options": {
      immediate: true,
      deep: true,

      handler(options) {
        if (!options || this.isLoading) return false;

        this.filter.storeOptions();
      },
    },
  },

  methods: {
    /**
     * Create new filter
     * @return {void}
     */
    handleOnCreateNewFilter() {
      this.filter.setSelectedOptions({
        column: "",
        contain: "",
        value: "",
      });
    },

    /**
     * To Remove selected filter
     * @param {number} index
     * @return {void}
     */
    handleOnRemoveFilter(index) {
      this.filter.removeSelectedOption(index);
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.isLoading = false;
    });
  },
};
</script>

<style scoped lang="scss" src="./styles.scss" />
